export default __webpack_public_path__ + "static/media/transaction_received _icon.424be922.svg";